// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e2a82d1","885":"535d8fbe"}[chunkId] + ".chunk.js";
};